import React from "react";

const Articles = () => {
  const [articlesData, setArticlesData] = React.useState([]);

  const fetchArticles = async () => {
    const response = await fetch(
      `https://api.rss2json.com/v1/api.json?rss_url=https://medium.com/feed/@kartikbudhraja`
    );
    const data = await response.json();
    setArticlesData(data?.items);
  };

  React.useEffect(() => {
    fetchArticles();
  }, []);

  const truncateHtml = (htmlString, length = 100) => {
    // Create a temporary div element
    const doc = new DOMParser().parseFromString(htmlString, "text/html");
    const text = doc.body.textContent || doc.body.innerText; // Get the plain text

    // Truncate the plain text and add '...' if it's longer than the specified length
    const truncatedText = text.slice(0, length);
    return truncatedText.length < text.length
      ? truncatedText + "..."
      : truncatedText;
  };

  return (
    <div className="col-span-1 lg:col-span-2">
      <div className="grid grid-cols-2 gap-6">
        <div className="col-span-2">
          <div className="card compact bg-base-100 shadow bg-opacity-40">
            <div className="card-body">
              <div className="mx-3 mb-2">
                <h5 className="card-title">
                  <span className="text-base-content opacity-70">
                    My Articles
                  </span>
                </h5>
              </div>
              <div className="col-span-2">
                <div className="grid grid-cols-1 gap-6 overflow-y-auto h-96">
                  {articlesData &&
                    articlesData.map((item, index) => (
                      <a
                        key={index}
                        className="card shadow-lg compact bg-base-100 cursor-pointer"
                        href={item?.link}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <div className="p-8 h-full w-full">
                          <div className="flex items-center flex-col md:flex-row">
                            <div className="avatar mb-5 md:mb-0 opacity-90">
                              <div className="w-24 h-24 mask mask-squircle">
                                <img
                                  src="https://upload.wikimedia.org/wikipedia/commons/e/ec/Medium_logo_Monogram.svg"
                                  alt="thumbnail"
                                />
                              </div>
                            </div>
                            <div className="w-full">
                              <div className="flex items-start px-4">
                                <div className="text-center md:text-left w-full">
                                  <h2 className="font-medium text-base-content opacity-60">
                                    {item?.title}
                                  </h2>
                                  <p className="text-base-content opacity-50 text-xs mt-2">
                                    {item?.pubDate.slice(0, 10)}
                                  </p>
                                  <div
                                    className="mt-2 text-base-content text-opacity-60 text-sm"
                                    dangerouslySetInnerHTML={{
                                      __html: truncateHtml(
                                        item.description || item.content,
                                        100
                                      ),
                                    }}
                                  />

                                  <div className="mt-4 flex items-center flex-wrap justify-center md:justify-start">
                                    {item?.categories.length > 0 &&
                                      item?.categories.map(
                                        (category, index) => (
                                          <div
                                            key={index}
                                            className="py-2 px-4 text-xs leading-3 rounded-full bg-base-300 mr-1 mb-1 opacity-50 text-base-content"
                                          >
                                            {category}
                                          </div>
                                        )
                                      )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </a>
                    ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Articles;
